module.exports = __webpack_public_path__ + "static/media/chat.c8e111c7.svg";